export const environment = {
    local: false,
    apiUrlOrigin: 'https://api.bannerflow.com',
    auth: {
        domain: 'https://login.bannerflow.com',
        clientId: '8EyHTZN7ilcVMCGyYYfj1CRFvQ8O9Esm',
    },
};
